import React, { useState, useEffect } from 'react';

export default function PageHeader() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formattedTime = currentTime.toLocaleTimeString();
  const formattedDate = currentTime.toLocaleDateString('en-US', {
    weekday: 'short',
    day: 'numeric',
    month: 'short', 
    year: 'numeric',
  });

  return (
    <>
      <div className="container-fluid top_header_div mt-2 mb-3">
        <div className="row">
          <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-2 col-sm-2 col-2 mx-auto p-2">
            <div className="orange_bg_color rounded p-3 text-center" data-bs-toggle="offcanvas" data-bs-target="#side_menu" aria-controls="side_menu">
              <i class="fa-solid fa-bars" style={{color: '#ffffff', fontSize: '40px'}}></i>
            </div>
          </div>

          <div className="col-xxl-11 col-xl-11 col-lg-11 col-md-10 col-sm-10 col-10 mx-auto p-2">
            <div className="orange_bg_color rounded p-4">
              <p className='mb-0 text-end' style={{ color: '#ffffff', textTransform: 'uppercase', fontSize: '20px' }}>
                <strong>Barista Pepiliyana</strong>  |  {formattedDate}  |  {formattedTime}
              </p>
            </div>
          </div>
        </div>
      </div>


      {/* side menu */}
      <div class="offcanvas offcanvas-start" tabindex="-1" id="side_menu" aria-labelledby="side_menu_Label">
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="side_menu_Label">Offcanvas</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <div>
            Some text as placeholder. In real life you can have the elements you have chosen. Like, text, images, lists, etc.
          </div>
        </div>
      </div>
      {/* side menu */}
    </>
  );
}

